import { Post } from '@wellesley/openapi'

const findAllFeedsAndUpdate = (
  feeds: Post[],
  feedId: string,
  update: (feed1: Post, feed2?: Post, index?: number) => void,
  onlyTopLevel = false,
) => {
  feeds.forEach((f, index) => {
    if (feedId === f.originalPost?.id) update(f.originalPost || f, f, index)
    else if (feedId === f.id) update(f, f, index)

    if (!f.replies?.length || onlyTopLevel) return

    findAllFeedsAndUpdate(f.replies, feedId, update)
  })
}

export default findAllFeedsAndUpdate
